export class VaultDocumentDTO{
    public id?:number;
    public businessId!:string;
    public clientId?:number;
    public filename?:string;
    public description?:string;
    public filepath!:string;
    public contentType?:string;
    public context?:string;
    public contextId?:number;
    public contextHeader?:string;
    public subContextId?:number; 
    public restrictedToUserId?:string;
    public visibility?:number; 
    public visibleTo?:number|null; //roles bitmask, see VisibleTo
    public documentTypeId!:number;
    public added?:string;
    public addedByUser?:string;
    public addedByUserFullName?:string;
    public edited?:string;
    public lastEditedByUser?:string;
    public folderStructureId?:number;
    public folderStructurePath?:string;
    public categoryType?: string;
    public categorySubType?: string;
    public categoryId?: number;
}